// Servicio dedicado al endpoint AISLADO de historial de stock.
// No comparte base URL con insumosService.js a propósito: son dos
// backends independientes (el de captura/producción y el de consulta
// histórica de solo lectura).

const STOCK_HISTORIAL_API_BASE_URL =
  "https://3ubh125u3b.execute-api.us-east-1.amazonaws.com/dev";

async function fetchJson(url) {
  const response = await fetch(url);

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    throw new Error(
      errorBody.error || `Error ${response.status} consultando historial de stock`
    );
  }

  return response.json();
}

/**
 * Últimas 30 capturas de una oficina, más reciente primero.
 */
export async function getHistorialReciente(oficinaId) {
  const url = `${STOCK_HISTORIAL_API_BASE_URL}/stock/historial/${encodeURIComponent(
    oficinaId
  )}`;
  return fetchJson(url);
}

/**
 * Snapshot vigente de una oficina en una fecha específica (o el más
 * cercano anterior a esa fecha).
 * @param {string} oficinaId
 * @param {string} fecha - formato YYYY-MM-DD
 */
export async function getSnapshotEnFecha(oficinaId, fecha) {
  const url = `${STOCK_HISTORIAL_API_BASE_URL}/stock/historial/${encodeURIComponent(
    oficinaId
  )}?fecha=${encodeURIComponent(fecha)}`;
  return fetchJson(url);
}

/**
 * Timeline completo de una oficina en un rango de fechas.
 * @param {string} oficinaId
 * @param {string} desde - formato YYYY-MM-DD
 * @param {string} hasta - formato YYYY-MM-DD
 */
export async function getHistorialEnRango(oficinaId, desde, hasta) {
  const url = `${STOCK_HISTORIAL_API_BASE_URL}/stock/historial/${encodeURIComponent(
    oficinaId
  )}?desde=${encodeURIComponent(desde)}&hasta=${encodeURIComponent(hasta)}`;
  return fetchJson(url);
}
